import React from "react";
import EntityTable from "../EntityTable";
import {
  anchorConnectionColumnId,
  renderRowUpdateAction,
} from "../../common/TableUtils";
import { ConnectionFormDataController } from "../../controllers/formController";
import useContributorQuery from "../../hooks/query/connections/useContributorQuery";
import { Version } from "../../types/version";
import { Person } from "../../types/person";
import {
  ContributorConnection,
  SystemContributorTypes,
} from "../../types/contributor";
import {
  contributorColumns,
  contributorFilterSpec,
} from "../../common/entities/ContributorColumns";
import ContributorDialog from "../modals/Contributor/ContributorDialog";
import useServerFilters from "../../hooks/useServerFilters";

interface ContributorTableProps {
  controller: ConnectionFormDataController<
    ContributorConnection,
    Version,
    Person
  >;
  contributorType: SystemContributorTypes;
  systemLanguageType: ContributorConnection["system_language_type"];
}

const ContributorTable: React.FC<ContributorTableProps> = ({
  controller,
  contributorType,
  systemLanguageType,
}) => {
  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters<ContributorConnection>({}, contributorFilterSpec);
  const { useFetchConnectedEdges } = useContributorQuery(
    contributorType,
    systemLanguageType
  );
  const { anchorEntity, direction, openEditDialog } = controller;
  const { data, isLoading, errorMessage } = useFetchConnectedEdges(
    anchorEntity._id,
    direction,
    {
      bodyParams: serverFilters,
      externalPagination: pagination,
      externalSetPagination: setPagination,
    }
  );

  const renderRowActions = renderRowUpdateAction<ContributorConnection>((row) =>
    openEditDialog(row._key)
  );

  return (
    <>
      <EntityTable
        loading={isLoading}
        error={errorMessage}
        columns={contributorColumns}
        hiddenColumnIds={[anchorConnectionColumnId(direction)]}
        renderRowActions={renderRowActions}
        enableRowActions
        data={data?.data || []}
        pagination={pagination}
        manualPagination
        onPaginationChange={setPagination}
        totalRowCount={data?.total || 0}
        manualFiltering
        {...entityTableFilterProps}
      />
      <ContributorDialog
        controller={controller}
        contributorType={contributorType}
        systemLanguageType={systemLanguageType}
      />
    </>
  );
};

export default ContributorTable;
